// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__y1Mx9"};